__turbopack_context__.v({
  "doublelinkcontainer": "linkComponent-module-scss-module__aV1M2a__doublelinkcontainer",
  "hr": "linkComponent-module-scss-module__aV1M2a__hr",
  "link": "linkComponent-module-scss-module__aV1M2a__link",
});
